import Seo from "../../../../src/components/seo";
import HeroPages from "../../../../src/components/heroes/hero-pages";
import { Container } from 'react-bootstrap';
import * as React from 'react';
export default {
  Seo,
  HeroPages,
  Container,
  React
};